export enum WebEnvironment {
	Prod = 'prod',
	N1QA = 'n1qa',
	N1DEV = 'n1dev',
	Local = 'local',
}
